import { render } from "./SueChat.vue?vue&type=template&id=773d6b66&scoped=true"
import script from "./SueChat.vue?vue&type=script&lang=js"
export * from "./SueChat.vue?vue&type=script&lang=js"

import "./SueChat.vue?vue&type=style&index=0&id=773d6b66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773d6b66"]])

export default __exports__